"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Axis = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var d3 = tslib_1.__importStar(require("d3"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var AxisUtils_1 = require("./AxisUtils");
var Axis = (function (_super) {
    tslib_1.__extends(Axis, _super);
    function Axis(props) {
        var _this = _super.call(this, props) || this;
        _this.createAttributes = _this.createAttributes.bind(_this);
        _this.StyledAxis = null;
        _this.AxisLabel = null;
        _this.AxisLine = null;
        return _this;
    }
    Axis.prototype.componentDidMount = function () {
        this.createAttributes();
    };
    Axis.prototype.componentDidUpdate = function () {
        this.createAttributes();
    };
    Axis.prototype.createAttributes = function () {
        var _a = this.props, orientation = _a.orientation, scale = _a.scale, height = _a.height, width = _a.width, gridLines = _a.gridLines, ticks = _a.ticks, tickValues = _a.tickValues, tickFormat = _a.tickFormat, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.unit, unit = _c === void 0 ? '' : _c, tickLabelAnchor = _a.tickLabelAnchor, _d = _a.axisExtension, axisExtension = _d === void 0 ? 0 : _d, _e = _a.axisLabelPadding, axisLabelPadding = _e === void 0 ? 0 : _e, maxAxisLabelWidth = _a.maxAxisLabelWidth, _f = _a.tickLabelOverflowMethod, tickLabelOverflowMethod = _f === void 0 ? 'WRAP' : _f, type = _a.type;
        var _g = AxisUtils_1.getAxisPropertiesByType(orientation, height, width, axisExtension, scale, axisLabelPadding), tickSize = _g.tickSize, axisTransformation = _g.axisTransformation, axisLabelTransformation = _g.axisLabelTransformation, tickLabelDominantBaseline = _g.tickLabelDominantBaseline, tickLabelTransform = _g.tickLabelTransform, line = _g.line, scaledAxis = _g.scaledAxis;
        if (ticks)
            scaledAxis.ticks(ticks);
        if (tickFormat)
            scaledAxis.tickFormat(tickFormat);
        if (tickValues)
            scaledAxis.tickValues(tickValues);
        if (tickSize)
            scaledAxis.tickSize(tickSize);
        scaledAxis.tickSizeOuter(0);
        var axis = d3.select(this.StyledAxis);
        var selection = axis
            .attr('transform', axisTransformation)
            .call(scaledAxis);
        if (orientation === 'BOTTOM' &&
            type === 'BAND' &&
            tickLabelOverflowMethod !== 'NONE') {
            axis.selectAll('.tick text').attr('display', 'none');
            axis.selectAll('foreignObject.wrapped-label').remove();
            var periodWidth = width / scale.domain().length;
            axis
                .selectAll('g.tick')
                .append('svg:foreignObject')
                .attr('class', 'wrapped-label')
                .attr('width', periodWidth)
                .attr('height', 50)
                .attr('x', (periodWidth / 2) * -1)
                .attr('y', '0.71em')
                .append('xhtml:div')
                .attr('class', tickLabelOverflowMethod === 'WRAP'
                ? 'x-axis-label'
                : 'x-axis-label truncate')
                .html(function (d, i) {
                return tickFormat ? tickFormat(d, i) : d;
            });
        }
        selection
            .selectAll('line')
            .style('shape-rendering', 'crispedges')
            .attr('opacity', function (d) {
            if (d !== 0 && gridLines === 'ZERO_ONLY') {
                return 0;
            }
            return 1;
        });
        selection
            .selectAll('text')
            .attr('transform', tickLabelTransform)
            .attr('text-anchor', tickLabelAnchor)
            .attr('dominant-baseline', tickLabelDominantBaseline);
        d3.select(this.AxisLabel)
            .attr('transform', axisLabelTransformation)
            .attr('text-anchor', 'start')
            .attr('dominant-baseline', 'middle')
            .text(label + " " + unit);
        d3.select(this.AxisLine)
            .attr('x1', line.x1)
            .attr('x2', line.x2)
            .attr('y1', line.y1)
            .attr('y2', line.y2);
        selection
            .selectAll('.tick')
            .attr('class', function (d) {
            return AxisUtils_1.getTickClassname(scale, d, width, height, orientation);
        });
        d3.selectAll('.tick line').attr('class', function (d) {
            return d === 0 ? 'tick_line_0' : null;
        });
        if (maxAxisLabelWidth) {
            var axisNode = d3.select(this.AxisLabel).node();
            var axisLabelDimensions = axisNode && axisNode.getBBox ? axisNode.getBBox() : null;
            if (axisLabelDimensions &&
                axisLabelDimensions.width &&
                axisLabelDimensions.width >= maxAxisLabelWidth) {
                d3.select(this.AxisLabel).text(AxisUtils_1.getTruncatedAxisLabel(18, label) + " " + unit);
            }
        }
    };
    Axis.prototype.render = function () {
        var _this = this;
        var _a = this.props, gridLines = _a.gridLines, _b = _a.displayLine, displayLine = _b === void 0 ? true : _b, type = _a.type, bold = _a.bold, _c = _a.mixBlendMode, mixBlendMode = _c === void 0 ? 'inherit' : _c, _d = _a.boldZeroLine, boldZeroLine = _d === void 0 ? true : _d;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledAxis, { displayLine: displayLine, gridLines: gridLines, type: type, bold: bold, mixBlendMode: mixBlendMode, boldZeroLine: boldZeroLine },
                react_1.default.createElement("g", { ref: function (el) { return (_this.StyledAxis = el); } }),
                react_1.default.createElement("line", { className: "axisLine", ref: function (el) { return (_this.AxisLine = el); }, stroke: "gray", strokeWidth: "1" })),
            react_1.default.createElement(AxisLabel, { ref: function (el) { return (_this.AxisLabel = el); } })));
    };
    return Axis;
}(react_1.PureComponent));
exports.Axis = Axis;
var StyledAxis = styled_components_1.default.g(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n\n  .domain {\n    display: none;\n  }\n\n  .axisLine {\n    display: ", ";\n    stroke: ", ";\n  }\n\n  .tick {\n    line {\n      color: ", ";\n      mix-blend-mode: ", ";\n    }\n\n    .tick_line_0 {\n      color: ", ";\n      mix-blend-mode: ", ";\n    }\n\n    text {\n      font-family: ", ";\n      font-size: 1.2rem;\n      fill: ", ";\n    }\n\n    .x-axis-label {\n      font-family: ", ";\n      text-align: center;\n      font-size: 1.2rem;\n      font-color: ", ";\n    }\n\n    .truncate {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n\n    .truncate:hover {\n      text-overflow: visible;\n      overflow: visible;\n      white-space: normal;\n    }\n  }\n\n  .tick_out_of_range {\n    display: none;\n  }\n"], ["\n  color: ", ";\n\n  .domain {\n    display: none;\n  }\n\n  .axisLine {\n    display: ", ";\n    stroke: ", ";\n  }\n\n  .tick {\n    line {\n      color: ",
    ";\n      mix-blend-mode: ", ";\n    }\n\n    .tick_line_0 {\n      color: ",
    ";\n      mix-blend-mode: ", ";\n    }\n\n    text {\n      font-family: ",
    ";\n      font-size: 1.2rem;\n      fill: ", ";\n    }\n\n    .x-axis-label {\n      font-family: ",
    ";\n      text-align: center;\n      font-size: 1.2rem;\n      font-color: ", ";\n    }\n\n    .truncate {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n\n    .truncate:hover {\n      text-overflow: visible;\n      overflow: visible;\n      white-space: normal;\n    }\n  }\n\n  .tick_out_of_range {\n    display: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[700];
}, function (_a) {
    var displayLine = _a.displayLine;
    return (displayLine ? 'inherit' : 'none');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[400];
}, function (_a) {
    var gridLines = _a.gridLines, theme = _a.theme;
    return gridLines ? theme.colors.NTDarkGrey[100] : 'transparent';
}, function (_a) {
    var mixBlendMode = _a.mixBlendMode;
    return mixBlendMode;
}, function (_a) {
    var gridLines = _a.gridLines, theme = _a.theme, boldZeroLine = _a.boldZeroLine;
    if (!gridLines)
        return 'transparent';
    return boldZeroLine
        ? theme.colors.NTDarkGrey[300]
        : theme.colors.NTDarkGrey[100];
}, function (_a) {
    var mixBlendMode = _a.mixBlendMode;
    return mixBlendMode;
}, function (_a) {
    var theme = _a.theme, bold = _a.bold;
    return bold ? theme.fonts.robotoMonoBold : theme.fonts.robotoMonoRegular;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[700];
}, function (_a) {
    var theme = _a.theme, bold = _a.bold;
    return bold ? theme.fonts.robotoMonoBold : theme.fonts.robotoMonoRegular;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[700];
});
var AxisLabel = styled_components_1.default.text(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-size: 1.2rem;\n  font-family: ", ";\n  fill: ", ";\n"], ["\n  font-size: 1.2rem;\n  font-family: ", ";\n  fill: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[700];
});
Axis.displayName = 'FOS_ChartAxis';
var templateObject_1, templateObject_2;
